import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../components/buttons/Button";
import Breadcrumbs from "../../../components/BreadCrumbs";
import StyledHeadingText from "../../../components/Fonts/StyledHeadingText";
import { toast } from "react-toastify";
import CustomLoading from "../../../components/customLoading/CustomLoading";
import Pagination from "../../../components/tables/pagination/Pagination";
import Table from "../../../components/tables/Table";
import { formatDateTime } from "../../../utils/FormatDateTime";
import { RiDeleteBin6Line } from "react-icons/ri";
import { TbPdf } from "react-icons/tb";
import ConfirmModal from "../../../components/popups/confirmationModal/ConfirmModal";
import ViewPdfModal from "../../../components/PdfViewer/ViewPdfModal";
import PatientPhotoGalleryComponent from "../../../components/PatientPhotoGalleryComponent";
import FileUploadModal from "../../../components/FileUploadModal";
import { deleteNewHudPatientsPdfs, deleteNewHudPatientsPhoto, getNewHudPatientsPdfs, getNewHudPatientsPhotos, postNewHudPatientsPdfs, postNewHudPatientsPhotos } from "../../../services/new_clinic/new_hud_patients";

const NewPatientFiles = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [rowData, setRowData] = useState({});
    const headers = [
        { label: "Uploaded On", key: "created_at" },
        { label: "Image", key: "image" },
        // { label: "Action", key: "action" },
    ];
    const headers2 = [
        { label: "Uploaded On", key: "created_at" },
        { label: "PDF", key: "pdf" },
        // { label: "Action", key: "action" },
    ];
    const [tableData, setTableData] = useState({});
    const [tableData2, setTableData2] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPage2, setCurrentPage2] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);

    const pageSize = 10;

    const fetchData = async (patientId) => {
        setLoading(true);
        try {
            let res = await getNewHudPatientsPhotos(patientId);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to Photos");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Photos:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchData2 = async (value) => {
        setLoading2(true);
        try {
            let res = await getNewHudPatientsPdfs(value);
            if (res.status === 200) {
                setTableData2(res.data);
            } else {
                toast.error("Unable to fetch PDFs");
            }
            setLoading2(false);
        } catch (error) {
            console.error("Error fetching PDFs:", error);
        } finally {
            setLoading2(false);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePageChange2 = (page) => {
        setCurrentPage2(page);
    };

    useEffect(() => {
        const patientData = location.state;
        if (patientData) {
            setRowData(patientData);
            fetchData(patientData.id);
            fetchData2(patientData.id);
        } else {
            toast.error("Error while looking for patient");
            navigate("/new-hud-patients");
        }
    }, [location.state]);

    const choosePhoto = () => {
        setIsImageUploadModalOpen(true);
    };

    const handlePhotoSubmit = async (file) => {
        const formData = new FormData();
        formData.append('photo', file);
        setLoading(true);
        try {
            const response = await postNewHudPatientsPhotos(rowData.id, formData);

            if (response.status === 201) {
                fetchData(rowData.id);
                toast.success("Image uploaded successfully");
            } else {
                toast.error("Unable to upload image");
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to upload photo');
        } finally {
            setLoading(false);
        }
    };

    const choosePdf = () => {
        setIsPdfUploadModalOpen(true);
    };

    const handlePdfSubmit = async (file) => {
        const formData = new FormData();
        formData.append('pdf', file);

        setLoading2(true);
        try {
            const response = await postNewHudPatientsPdfs(rowData.id, formData);
            if (response.status === 201) {
                fetchData2(rowData.id);
                toast.success("PDF uploaded successfully");
            } else {
                toast.error("Unable to upload PDF");
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to upload pdf');
        } finally {
            setLoading2(false);
        }
    };

    // const handlePhotoDelete = async () => {
    //     if (!photoDeleteId) return;
    //     setLoading(true);
    //     try {
    //         const response = await deleteNewHudPatientsPhoto(rowData.id, photoDeleteId);
    //         if (response.status === 204) {
    //             fetchData(rowData.id);
    //             toast.success("Photo deleted successfully");
    //         } else {
    //             toast.error("Unable to delete Photo");
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //         toast.error('Failed to delete photo');
    //     } finally {
    //         setLoading(false);
    //         closePhotoModal();
    //     }
    // };

    const [modalIsPdfOpen, setIsPdfOpen] = useState(false);
    const [pdfToDisplay, setPdfToDisplay] = useState({});

    // Upload modal states
    const [isImageUploadModalOpen, setIsImageUploadModalOpen] = useState(false);
    const [isPdfUploadModalOpen, setIsPdfUploadModalOpen] = useState(false);

    // const [modalIsOpen, setIsOpen] = useState(false);
    // const [isConfirmDelete, setIsConfirmDelete] = useState(false);
    // const [pdfDeleteId, setPdfDeleteId] = useState(null);

    // const [modalIsPhotoOpen, setIsPhotoOpen] = useState(false);
    // const [isConfirmPhotoDelete, setIsConfirmPhotoDelete] = useState(false);
    // const [photoDeleteId, setPhotoDeleteId] = useState(null);


    const openPdfModal = (row) => {
        setPdfToDisplay(row?.pdf);
        setIsPdfOpen(true);
    };

    const closePdfModal = () => {
        setIsPdfOpen(false);
    };

    // // Close modal
    // const closeModal = () => {
    //     setIsOpen(false);
    //     setIsConfirmDelete(false);
    //     setPdfDeleteId(null);
    // };

    // // Open modal with the selected PDF ID
    // const openModal = (id) => {
    //     setPdfDeleteId(id);
    //     setIsOpen(true);
    // };

    // const closePhotoModal = () => {
    //     setIsPhotoOpen(false);
    //     setIsConfirmPhotoDelete(false);
    //     setPhotoDeleteId(null);
    // };

    // // Open modal with the selected PDF ID
    // const openPhotoModal = (id) => {
    //     setPhotoDeleteId(id);
    //     setIsPhotoOpen(true);
    // };

    // // Delete PDF
    // const handlePdfDelete = async () => {
    //     if (!pdfDeleteId) return;
    //     setLoading2(true);
    //     try {
    //         const response = await deleteNewHudPatientsPdfs(rowData.id, pdfDeleteId);
    //         if (response.status === 204) {
    //             fetchData2(rowData.id);
    //             toast.success("PDF deleted successfully");
    //         } else {
    //             toast.error("Unable to delete PDF");
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //         toast.error('Failed to delete PDF');
    //     } finally {
    //         setLoading2(false);
    //         closeModal();
    //     }
    // };

    // useEffect(() => {
    //     if (isConfirmDelete) {
    //         handlePdfDelete();
    //     }
    // }, [isConfirmDelete]);

    // useEffect(() => {
    //     if (isConfirmPhotoDelete) {
    //         handlePhotoDelete();
    //     }
    // }, [isConfirmPhotoDelete]);

    // Handle file upload from modal
    const handleImageUpload = async (files) => {
        // Handle multiple files for new clinic dashboard
        if (Array.isArray(files)) {
            for (const file of files) {
                await handlePhotoSubmit(file);
            }
        } else {
            await handlePhotoSubmit(files);
        }
    };

    const handlePdfUpload = async (file) => {
        await handlePdfSubmit(file);
    };

    return (
        <div className="p-6 bg-white rounded-lg shadow-md" onContextMenu={e => e.preventDefault()}>
            <Breadcrumbs items={[
                { name: 'Home', link: '/package-invoice' },
                { name: 'Patients', link: '/new-hud-patients' },
                { name: 'Patient Files' },
            ]} />
            <div className="my-4">
                <StyledHeadingText text={`${rowData.name} (${"Age: " + rowData.age || "DOB: " + rowData.dob} | Gen: ${rowData.gender})`} />
            </div>
            <div className="mt-2 flex flex-col xl:flex-row gap-3">
                <div className="w-full flex-1">
                    <div className="flex flex-row justify-between items-center my-4">
                        <StyledHeadingText text={"Images"} />
                        <Button
                            type="button"
                            className="bg-primary text-white px-4 py-2 rounded"
                            onClick={choosePhoto}
                            disabled={loading}
                        >
                            {loading ? "Uploading..." : "Add Image"}
                        </Button>
                    </div>
                    {loading ?
                        <div className="flex w-full flex-row justify-center my-2">
                            <CustomLoading size={100} />
                        </div>
                        :
                        <Table
                            headers={headers}
                            rows={tableData?.results?.map((item, index) => (
                                {
                                    created_at: <p>{formatDateTime(item.created_at)}</p>,
                                    image: <div className="h-10 w-10 border border-gray-300 rounded-md"><PatientPhotoGalleryComponent imageToDisplay={item.photo} images={tableData.results} activeIndex={index} className="aspect-square rounded-md max-w-10 border shadow-lg" /></div>,
                                    // action: <Button onClick={() => openPhotoModal(item.PatientHistoryPhotos_id)}> <RiDeleteBin6Line color="red" size={24} /></Button>,
                                }))}
                        />
                    }
                    {tableData.count !== 0 ?
                        <div className="xl:pl-5 pl-0 w-full flex-1">
                            <Pagination
                                currentPage={currentPage}
                                totalPages={Math.ceil(tableData?.count / pageSize)}
                                pageSize={pageSize}
                                totalEntries={tableData?.count}
                                onPageChange={handlePageChange}
                                data={tableData}
                                setTableData={setTableData}
                            />
                        </div> : <></>}
                </div>
                <div className="w-full flex-1">
                    <div className="flex flex-row justify-between items-center my-4">
                        <StyledHeadingText text={"PDFs"} />
                        <Button
                            type="button"
                            className="bg-primary text-white px-4 py-2 rounded"
                            onClick={choosePdf}
                            disabled={loading2}
                        >
                            {loading ? "Uploading..." : "Add PDF"}
                        </Button>
                    </div>
                    {loading2 ?
                        <div className="flex w-full flex-row justify-center my-2">
                            <CustomLoading size={100} />
                        </div>
                        :
                        <Table
                            headers={headers2}
                            rows={tableData2?.results?.map((item, index) => (
                                {
                                    created_at: <p>{formatDateTime(item.created_at)}</p>,
                                    pdf: <Button onClick={() => openPdfModal(item)}><TbPdf size={24} color="green" /> </Button>,
                                    // action: <Button onClick={() => openModal(item.PatientHistoryPdfs_id)}><RiDeleteBin6Line color="red" size={24} /></Button>,
                                }))}
                        />
                    }
                    {tableData2.count !== 0 ?
                        <div className="xl:pl-5 pl-0 w-full flex-1">
                            <Pagination
                                currentPage={currentPage2}
                                totalPages={Math.ceil(tableData2?.count / pageSize)}
                                pageSize={pageSize}
                                totalEntries={tableData2?.count}
                                onPageChange={handlePageChange2}
                                data={tableData2}
                                setTableData={setTableData2}
                            />
                        </div> : <></>}
                </div>
            </div>

            <div className="flex gap-4 justify-end w-full mt-4">
                <Button
                    type="button"
                    className="bg-gray-500 text-white px-4 py-2 rounded"
                    onClick={() => navigate("/new-hud-patients")}
                >
                    Back
                </Button>
            </div>
            {/* <ConfirmModal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Delete Confirmation"
                onClose={closeModal}
                setIsConfirmDelete={setIsConfirmDelete}
                title="Are you sure you want to delete this PDF?"
                icon={
                    <RiDeleteBin6Line color="red" size={60} />
                }
            />
            <ConfirmModal
                isOpen={modalIsPhotoOpen}
                onRequestClose={closePhotoModal}
                contentLabel="Delete Confirmation"
                onClose={closePhotoModal}
                setIsConfirmDelete={setIsConfirmPhotoDelete}
                title="Are you sure you want to delete this Photo?"
                icon={
                    <RiDeleteBin6Line color="red" size={60} />
                }
            /> */}
            <ViewPdfModal contentLabel={"PDF"} isOpen={modalIsPdfOpen} onRequestClose={closePdfModal} pdfUrl={pdfToDisplay} />

            {/* Upload Modals */}
            <FileUploadModal
                isOpen={isImageUploadModalOpen}
                onClose={() => setIsImageUploadModalOpen(false)}
                onFileSelect={handleImageUpload}
                fileType="image"
                multiple={true}
                maxFiles={20}
                loading={loading}
            />
            <FileUploadModal
                isOpen={isPdfUploadModalOpen}
                onClose={() => setIsPdfUploadModalOpen(false)}
                onFileSelect={handlePdfUpload}
                fileType="pdf"
                multiple={false}
                loading={loading2}
            />
        </div >
    );
};

export default NewPatientFiles;
